import IsAddHomeVideo from "./IsAddHomeVideo"

export interface Props {
  checked: boolean
  isDisabled: boolean
  onChange: () => void
}

export interface ComponentProps extends Props {}

export default IsAddHomeVideo
